// Imagery for the public website. The warehouse/fabrication/showroom frames were
// made for Brioni; lifestyle shots are stock and are all replaceable from
// Settings → Public Website. Real project photos come live from the CRM.
export const SITE_IMG = {
  hero: "https://static.prod-images.emergentagent.com/jobs/781411cb-4ab0-471d-8410-357e2b46a8d2/images/83cb2ccd2da7f61c30421cece4804646a2c06dcd41ab1d3abc0a62d305055ae5.jpeg",
  warehouse:
    "https://static.prod-images.emergentagent.com/jobs/781411cb-4ab0-471d-8410-357e2b46a8d2/images/075b1a6a68fb8bc1a366929c46797af5a1ce43b88f7ef408b72b08133ba0c5bb.jpeg",
  fabrication:
    "https://static.prod-images.emergentagent.com/jobs/781411cb-4ab0-471d-8410-357e2b46a8d2/images/c858aec13b3f72b94410ec4321ab8c0aa5427b876edf20cb2b7ae3c9ba489e4f.jpeg",
  polishing:
    "https://static.prod-images.emergentagent.com/jobs/781411cb-4ab0-471d-8410-357e2b46a8d2/images/7d746ec27394a466db0de18c238417cfd4c3a77b020ae7a269de2f2770c0b3a5.jpeg",
  kitchen:
    "https://images.unsplash.com/photo-1738748444653-2fb1388aef1a?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  kitchen2:
    "https://images.unsplash.com/photo-1782392440011-b0bb69d31a26?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  kitchenDark:
    "https://images.unsplash.com/photo-1778272617843-bdda47b64bad?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  bath: "https://images.unsplash.com/photo-1777014547456-7d94a04382ee?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  bath2:
    "https://images.unsplash.com/photo-1754788358645-d6e6cca12e25?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  fireplace:
    "https://static.prod-images.emergentagent.com/jobs/781411cb-4ab0-471d-8410-357e2b46a8d2/images/8635df87ea7acd3e1225a2aa87969caec13b582f4232b1cdef2caf0a73bd8b69.jpeg",
  outdoor:
    "https://static.prod-images.emergentagent.com/jobs/781411cb-4ab0-471d-8410-357e2b46a8d2/images/043df4c8e7af3ddb01335e8d7f9610e628a71f0e57f36cb39b9b1c221107c758.jpeg",
  outdoor2:
    "https://images.unsplash.com/photo-1762117361025-52f24e45d9ac?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  walls:
    "https://static.prod-images.emergentagent.com/jobs/781411cb-4ab0-471d-8410-357e2b46a8d2/images/ff0197a9f509d2be8527023ef67b55220ac6e31e29d2194dd8a2153f3368043b.jpeg",
  detail:
    "https://images.unsplash.com/photo-1523251836828-b75d28b89804?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  quartz:
    "https://images.unsplash.com/photo-1603323978104-4c1c0d1bfc72?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  granite:
    "https://images.unsplash.com/photo-1680169296968-f1079bf1f342?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  quartzite:
    "https://images.unsplash.com/photo-1558346648-9757f2fa4474?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  neolith:
    "https://images.unsplash.com/photo-1566305977571-5666677c6e98?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

export const MATERIALS = [
  {
    name: "Quartz",
    img: SITE_IMG.quartz,
    blurb:
      "Engineered, non-porous, consistent veining. Kitchens that stay easy.",
  },
  {
    name: "Granite",
    img: SITE_IMG.granite,
    blurb: "Hard-wearing natural stone. Heat proof and no two slabs alike.",
  },
  {
    name: "Quartzite",
    img: SITE_IMG.quartzite,
    blurb: "Marble looks with granite strength. Our most asked-for stone.",
  },
  {
    name: "Neolith",
    img: SITE_IMG.neolith,
    blurb:
      "Sintered stone for big spans, outdoor kitchens and full-height walls.",
  },
];

export const SERVICES = [
  {
    name: "Kitchens",
    img: SITE_IMG.kitchen,
    blurb:
      "Counters, islands, waterfalls and full-height splashbacks, templated to your cabinets.",
  },
  {
    name: "Bathrooms",
    img: SITE_IMG.bath,
    blurb: "Vanities, shower jambs, curbs and window sills cut from one slab.",
  },
  {
    name: "Fireplaces",
    img: SITE_IMG.fireplace,
    blurb:
      "Surrounds, hearths and mantels with mitred returns and matched veining.",
  },
  {
    name: "Outdoors",
    img: SITE_IMG.outdoor,
    blurb:
      "Grill islands, bar tops and pool surrounds in stone built for weather.",
  },
  {
    name: "Flooring & walls",
    img: SITE_IMG.walls,
    blurb: "Large-format stone for floors, feature walls and stair treads.",
  },
  {
    name: "Repair & polish",
    img: SITE_IMG.polishing,
    blurb:
      "Seam repairs, chip fills, re-polishing and new cut-outs in existing tops.",
  },
];

export const STEPS = [
  {
    title: "Talk it through",
    body: "Send your plans or drop by the warehouse. We price the job the same day where we can.",
  },
  {
    title: "Pick your slab",
    body: "Walk the racks and put your name on the exact slab you want held.",
  },
  {
    title: "Digital template",
    body: "We measure your cabinets to the 1/16in once they are in, then draw every piece.",
  },
  {
    title: "Fabrication",
    body: "Cut and polished in our own shop — seams and veining laid out on your slab first.",
  },
  {
    title: "Installation",
    body: "Set, sealed and cleaned by our own crew. Sinks and cook-tops dropped in.",
  },
  {
    title: "Aftercare",
    body: "Care sheet, leftover offcuts and a shop that answers the phone afterwards.",
  },
];

export const WHY = [
  {
    title: "Our own fabrication shop",
    body: "Nothing is sub-contracted. The slab you choose is the slab we cut.",
  },
  {
    title: "Vein matching",
    body: "Book-matched seams and waterfalls laid out on the real slab photo before cutting.",
  },
  {
    title: "Live slab inventory",
    body: "What you see on this site is what is standing in the racks today.",
  },
  {
    title: "Remnant program",
    body: "Small jobs get warehouse offcuts — vanities and hearths for a lot less.",
  },
  {
    title: "One stop shop",
    body: "Consult, design, template, fabricate, install. One crew, one number to call.",
  },
  {
    title: "Trade friendly",
    body: "Builders, kitchen studios and designers get drawings, holds and schedules.",
  },
];

// Stock picture to fall back on when the shop has not uploaded its own.
export const materialImg = (title) =>
  SITE_IMG[(title || "").toLowerCase()] || SITE_IMG.quartz;

export const serviceImg = (title) =>
  SERVICES.find((s) => s.name.toLowerCase() === (title || "").toLowerCase())
    ?.img || SITE_IMG.kitchen;

export const SUPPLIERS = [
  "MSI",
  "Cosentino",
  "Neolith",
  "Silestone",
  "Daltile",
  "Virginia Tile",
  "Stoneland",
  "Arc Surfaces",
  "Midwest Tile",
  "Two Rivers",
  "Vanguard",
];
